import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../store/store';
import SceneProseView from '../components/SceneProseView';

export const Prose = () => {
    const [state, actions] = useStore();
    const { currentNovel } = state;
    const { chapterId, sceneId } = useParams();

    const chapter = currentNovel?.chapters.find(c => c.id === chapterId);
    const scene = chapter?.scenes.find(s => s.id === sceneId);

    return (
        <div>
            <SceneProseView scene={scene} chapter={chapter}/>
        </div>
    );
};

export default Prose;